import * as React from 'react';
import './FlowProgressBar.less';
import classNames from 'classnames';
import { hasValue } from '../../lib/utils';

const FlowProgressBar = (props: Props) => {
	const progressLineVisibility = props.showFlowProgressBarLine ? 'visible' : 'hidden';
	// If there is no current bar name, then all pages are considered completed.
	const currentIndex = hasValue(props.currentFlowProgressBarName)
		? props.flowProgressBarNames.indexOf(props.currentFlowProgressBarName)
		: props.flowProgressBarNames.length;

	return (
		<div className="progressBar">
			{props.flowProgressBarNames.map((x, i) => {
				let status = '';
				if (i < currentIndex || props.showFlowProgressBarLine === false) {
					status = 'completed';
				} else if (i === currentIndex) {
					status = 'current';
				}

				const clickable =
					status === 'completed' && hasValue(props.navigateToPage) && x !== props.currentFlowProgressBarName;
				return (
					<section key={x}>
						{i !== 0 && (
							<div style={{ visibility: progressLineVisibility }} className={classNames('progressLine', status)} />
						)}
						<div style={{ visibility: progressLineVisibility }} className={classNames('progressIcon', status)} />
						<div
							onClick={() => clickable && props.navigateToPage(x)}
							className={classNames('progressText', status, clickable ? 'clickable' : null)}
						>
							{x}
						</div>
					</section>
				);
			})}
		</div>
	);
};

interface Props {
	navigateToPage: (flowProgressBarName: string) => void;
	flowProgressBarNames: string[];
	showFlowProgressBarLine?: boolean;
	currentFlowProgressBarName?: string;
}

FlowProgressBar.defaultProps = {
	currentFlowProgressBarName: null,
	showFlowProgressBarLine: true
};

export default FlowProgressBar;
